/* Peacock Life — Luxe services page helpers: smooth in-page links, service pre-selection in
   the enquiry form, the mobile consultation bar and the sticky-card offset under the header. */
(function () {
  'use strict';
  if (window.__luxeServices) return;
  window.__luxeServices = true;

  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Smooth jumps to #begin / #homes */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var t = id && document.getElementById(id);
    if (!t || !t.classList.contains('lxs')) return;
    e.preventDefault();
    var svc = a.getAttribute('data-lxs-service');
    if (svc) pick(svc);
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset(), behavior: 'smooth' });
  });

  /* Choose the matching option in the form's service dropdown */
  function pick(label) {
    var want = label.toLowerCase().replace(/\s+/g, ' ').trim();
    var sel = qa('#begin select');
    sel.forEach(function (s) {
      var opts = Array.prototype.slice.call(s.options);
      var hit = opts.filter(function (o) { return o.text.toLowerCase().replace(/\s+/g, ' ').trim() === want; })[0] ||
                opts.filter(function (o) { return o.text.toLowerCase().indexOf(want) === 0; })[0];
      if (!hit) return;
      s.value = hit.value;
      s.dispatchEvent(new Event('input', { bubbles: true }));
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* Height of a header that stays pinned, so stacked cards sit just below it */
  function offset() {
    var h = document.querySelector('.shopify-section-header-sticky, .section-header.shopify-section-header-sticky, sticky-header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return (getComputedStyle(h).position === 'sticky' || getComputedStyle(h).position === 'fixed') && r.bottom > 0 ? r.height : 0;
  }
  function setTop() {
    var o = 0;
    var h = document.querySelector('.shopify-section-header-sticky');
    if (h && !h.classList.contains('shopify-section-header-hidden')) o = h.getBoundingClientRect().height;
    var v = Math.round(o + (window.innerWidth < 990 ? 10 : 16));
    if (v === lastTop) return;
    lastTop = v;
    document.documentElement.style.setProperty('--lxs-top', v + 'px');
  }
  var lastTop = -1;

  /* Mobile bar: shows once the hero has gone, hides while the form is on screen */
  function initBar() {
    var bar = document.querySelector('.lxs-bar');
    var hero = document.querySelector('.lxs-hero');
    var begin = document.getElementById('begin');
    if (!bar || !('IntersectionObserver' in window)) return;
    var heroIn = !!hero, beginIn = false;
    function upd() { bar.classList.toggle('is-on', !heroIn && !beginIn); }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === hero) heroIn = e.isIntersecting;
        if (e.target === begin) beginIn = e.isIntersecting;
      });
      upd();
    }, { threshold: 0 });
    if (hero) io.observe(hero);
    if (begin) io.observe(begin);
    bar.removeAttribute('aria-hidden');
  }

  /* Home cards: as the next card slides over, the one beneath settles back and dims.
     Hero: once the house has formed, its buttons stop catching clicks. */
  var cards = [], hero = null, heroTrack = null, ticking = false;
  function frame() {
    ticking = false;
    var i, r = [];
    for (i = 0; i < cards.length; i++) r.push(cards[i].getBoundingClientRect());
    for (i = 0; i < cards.length - 1; i++) {
      var h = r[i].height || 1;
      var c = 1 - (r[i + 1].top - r[i].top) / h;
      c = c < 0 ? 0 : c > 1 ? 1 : c;
      c = Math.round(c * 100) / 100;
      if (cards[i]._c !== c) { cards[i]._c = c; cards[i].style.setProperty('--c', c); }
    }
    if (heroTrack) {
      var p = parseFloat(heroTrack.style.getPropertyValue('--p')) || 0;
      hero.classList.toggle('is-built', p > .3);
    }
  }
  function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  /* Phones: iOS Safari reloads the tab when a page holds too much graphics memory, which looks
     like the page jumping back to the top. So the hero stops painting once it is off screen, and
     films far from view release their buffered video (they reload when you scroll back). */
  function initMemory() {
    if (!('IntersectionObserver' in window) || window.innerWidth > 989) return;
    var h = document.querySelector('.lxs-hero');
    if (h) new IntersectionObserver(function (es) {
      es.forEach(function (e) { h.classList.toggle('is-away', !e.isIntersecting); });
    }, { rootMargin: '150px 0px' }).observe(h);

    var vids = qa('.lxs video');
    if (!vids.length) return;
    function unload(v) {
      if (v._lxsOff) return;
      v.pause();
      v._lxsOff = { src: v.getAttribute('src'), kids: qa('source', v) };
      v._lxsOff.kids.forEach(function (s) { v.removeChild(s); });
      v.removeAttribute('src');
      try { v.load(); } catch (err) {}
    }
    function restore(v) {
      var o = v._lxsOff;
      if (!o) return;
      v._lxsOff = null;
      o.kids.forEach(function (s) { v.appendChild(s); });
      if (o.src) v.setAttribute('src', o.src);
      try { v.load(); } catch (err) {}
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) restore(e.target); else unload(e.target); });
    }, { rootMargin: '120% 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() {
    setTop(); initBar(); initMemory();
    cards = qa('.lxs-card');
    hero = document.querySelector('.lxs-hero');
    heroTrack = hero && hero.querySelector('.lxs-hero__track');
    kick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', function () { setTop(); kick(); }, { passive: true });
  window.addEventListener('resize', function () { setTop(); kick(); }, { passive: true });
})();
